import React from 'react'
import { Box, Grid, Typography, Link, Button} from "@mui/material";
import { useNavigate } from "react-router-dom";
import imgUrl from "../../assets/images/imgUrl";

const Gifts = () => {
  const navigate = useNavigate();
  
  return (
    <>
    {/* Gift Hero Background Section */}
      <Box
        className="programGiftSectionBg commonBannerBg"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          px: 2,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 80,
            left: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
        </Box>
      </Box>

    {/* Gift Main Section */}
      <Box className="giftProgramSubSection">
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid
            
            size={12}
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
          >
            <img src={imgUrl.peaceIcon} className="w-100 peaceImg"></img>
            <Typography variant="h5" className="founder-title mainHeading green-title">
            <i> I Am Peacekeeper </i>  Gifts
            </Typography>
          </Grid>
        </Grid>
        <Box  display="flex"
            alignItems="center"
            justifyContent="center">
            <img src={imgUrl.peaceKeeperGifts} className='w-100 peacekeeperInfographic'></img>
        </Box>
        
      </Box>

       <Box mt={5}>
              <Grid container spacing={0}>
                <Grid
                  item
                  xs={12}
                  className="d-flex-align-center-justify-center flex-direction-column w-100"
                >
                  <Typography
                    variant="h5"
                    align="center"
                    fontWeight="bold"
                    gutterBottom
                    className="subHeading mb-0px subText"
                  >
                     Each gift is designed to inspire, support
                     <br></br>
                      peace and reward contributors. 
                  </Typography>
                  
                  {/* Login Button */}
                  {/* <Box sx={{ mt: 4, mb: 2 }}>
                    <Button
                      variant="contained"
                      onClick={() => navigate('/Gifts/Login')}
                      sx={{
                        background: 'linear-gradient(to right, #214F7D, #3A8139)',
                        color: 'white',
                        borderRadius: '50px',
                        px: 4,
                        py: 1.5,
                        fontSize: '1rem',
                        fontWeight: 500,
                        textTransform: 'none',
                        '&:hover': {
                          background: 'linear-gradient(to right, #1a3f63, #2d6329)',
                        }
                      }}
                    >
                      Login to Access Gifts
                    </Button>
                  </Box> */}
                </Grid>
              </Grid>
            </Box>

             {/* contact section */}
      <Box className="contactSchoolSection">
        <Typography
          variant="h5"
          align="center"
          fontWeight="bold"
          gutterBottom
          className="subHeading"
          mt={5}
          style={{marginBottom:"2px"}}
        >
          Contact
        </Typography>
        <div className="d-flex-align-center-justify-center flex-direction-column">
         
          <p className="mb-0px" mt={0}>
            <b>Email: </b>
            <Link href="mailto:gifts@i-am-peacekeeper.com" className='cursor-pointer'>gifts@i-am-peacekeeper.com </Link> 
          </p>
        </div>
      </Box>
    </>
  )
}

export default Gifts